import service from "@/store/services/purchases-orders-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  purchasesOrder: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, purchasesOrder) => {
    state.purchasesOrder = purchasesOrder;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((purchasesOrder) => {
      commit("SET_RESOURCE", purchasesOrder);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((purchasesOrder) => {
      commit("SET_RESOURCE", purchasesOrder);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((purchasesOrder) => {
      commit("SET_RESOURCE", purchasesOrder);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  validate({ commit, dispatch }, params) {
    return service.validate(params, this.$axios).then((purchasesOrder) => {
      commit("SET_RESOURCE", purchasesOrder);
    });
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((purchasesOrder) => {
      commit("SET_RESOURCE", purchasesOrder);
    });
  },

  generateInvoice({ commit, dispatch }, params) {
    return service.generateInvoice(params, this.$axios);
  },

  generateDelivery({ commit, dispatch }, params) {
    return service.generateDelivery(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  purchasesOrder: (state) => state.purchasesOrder,
  url: (state) => state.url,
};

const purchasesOrders = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default purchasesOrders;
